import styled, { css } from 'styled-components';
import { getMargins, SYS_SIZE_FIXED_1200, SYS_BORDER_RADIUS_MAX, SEM_BORDER_WIDTH_FORMS_DEFAULT, getTypographyStyles, SEM_TYPOGRAPHY_FORMS_INPUT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_150, SYS_BORDER_RADIUS_SM } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
import { Icon } from '../icon/index.js';
import { FormMessage } from '../form-message/index.js';
const ICON_SIZE = '24px';
export const StyledSearchField = styled.div `
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledSearchIcon = styled(Icon) `
  position: absolute;
  top: 50%;
  left: ${SYS_SPACE_FIXED_200};
  transform: translateY(-50%);
  color: ${(props) => props.theme.sem.color.forms.foreground.field.icon.default};
`;
export const StyledIconButtonContainer = styled.div `
  position: absolute;
  gap: ${SYS_SPACE_FIXED_100};
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  right: ${SYS_SPACE_FIXED_200};
`;
export const StyledIconButton = styled.button `
  color: ${(props) => props.theme.sem.color.forms.foreground.field.icon.default};
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  border-radius: ${SYS_BORDER_RADIUS_SM};
  line-height: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;
const getPaddingRight = (hasValue, hasButton) => {
    const padding = [SYS_SPACE_FIXED_200];
    if (hasValue) {
        padding.push(ICON_SIZE);
        padding.push(SYS_SPACE_FIXED_100);
    }
    if (hasButton) {
        padding.push(ICON_SIZE);
        padding.push(SYS_SPACE_FIXED_100);
    }
    return `calc(${padding.join(' + ')})`;
};
export const StyledInput = styled.input `
  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button {
    appearance: none;
  }
  width: 100%;
  min-height: ${SYS_SIZE_FIXED_1200};
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  box-sizing: border-box;
  border: none;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)}
  // TODO: tokens missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  padding: ${SYS_SPACE_FIXED_150}
    ${(props) => getPaddingRight(props.hasValue, props.additionalIconButton)}
    ${SYS_SPACE_FIXED_150}
    calc(${ICON_SIZE} + ${SYS_SPACE_FIXED_100} + ${SYS_SPACE_FIXED_200});
  transition-property: background, color, box-shadow;

  &:not(:disabled) {
    ${(props) => css `
      box-shadow: 0px 0px 0px ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
        ${props.theme.sem.color.forms.surface.field.stroke.default};
      background: ${props.theme.sem.color.forms.surface.field.fill.default};
      color: ${props.theme.sem.color.forms.foreground.field.input.default};

      &::placeholder {
        color: ${props.theme.sem.color.forms.foreground.field.placeholder
    .default};
      }
    `}

    &:hover, &:focus {
      ${(props) => css `
        background-color: ${props.theme.sem.color.forms.surface.field.fill
    .interactive};
        box-shadow: 0px 0px 0px ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
          ${props.theme.sem.color.forms.surface.field.stroke.interactive};
      `}
    }
  }

  &:disabled {
    cursor: not-allowed;
    ${(props) => css `
      box-shadow: 0px 0px 0px ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
        ${props.theme.sem.color.forms.surface.field.stroke.disabled};
      color: ${props.theme.sem.color.forms.foreground.field.input.disabled};
      background: ${props.theme.sem.color.forms.surface.field.fill.disabled};

      &::placeholder {
        color: ${props.theme.sem.color.forms.foreground.field.placeholder
    .disabled};
      }
    `}

    & + ${StyledIconButtonContainer} {
      ${StyledIconButton} {
        color: ${(props) => props.theme.sem.color.forms.foreground.field.icon.disabled};
      }
    }
  }

  /* Fixes white background-color that appeared in the SearchField when the auto-complete feature was used in Chrome. */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition:
      background-color 0s,
      color 0s;
    transition-delay: 99999s;
  }
`;
export const StyledUpperContainer = styled.div `
  position: relative;

  &:has(${StyledInput}:disabled) {
    ${StyledSearchIcon} {
      color: ${(props) => props.theme.sem.color.forms.foreground.field.icon.disabled};
    }
  }
`;
export const StyledFormMessage = styled(FormMessage) `
  padding: ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_200} 0
    ${SYS_SPACE_FIXED_200};
`;
//# sourceMappingURL=index.styles.js.map